import { observer } from "mobx-react-lite";
import { FC } from "react";

import {
  MessageBar,
  MessageBarType,
  Pivot,
  PivotItem,
  Stack
} from "@bps/fluent-ui";

import { useIntegrationScreenContext } from "../../context/IntegrationScreenContext.ts";
import { XeroOrganisationSelector } from "./XeroOrganisationSelector.tsx";
import { XeroSettingsForm } from "./XeroSyncSettingsForm.tsx";

export const XeroViewSelector: FC = observer(() => {
  const { organisationError } = useIntegrationScreenContext();

  return (
    <Stack>
      {organisationError && (
        <MessageBar messageBarType={MessageBarType.error}>
          {organisationError}
        </MessageBar>
      )}
      <Pivot>
        <PivotItem headerText="Organisation">
          <XeroOrganisationSelector />
        </PivotItem>
        <PivotItem headerText="Synchronisation">
          <XeroSettingsForm />
        </PivotItem>
      </Pivot>
    </Stack>
  );
});
